/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './Document';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';

/**
 * 
 * @export
 * @interface DocumentPageable
 */
export interface DocumentPageable {
    /**
     * Array of documents
     * @type {Array<Document>}
     * @memberof DocumentPageable
     */
    items: Array<Document>;
    /**
     * 
     * @type {Pageable}
     * @memberof DocumentPageable
     */
    meta: Pageable;
}

/**
 * Check if a given object implements the DocumentPageable interface.
 */
export function instanceOfDocumentPageable(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function DocumentPageableFromJSON(json: any): DocumentPageable {
    return DocumentPageableFromJSONTyped(json, false);
}

export function DocumentPageableFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentPageable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(DocumentFromJSON)),
        'meta': PageableFromJSON(json['meta']),
    };
}

export function DocumentPageableToJSON(value?: DocumentPageable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(DocumentToJSON)),
        'meta': PageableToJSON(value.meta),
    };
}

